import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Clickable floor/level header that shows/hides children.
 * Defaults to open so existing layouts stay fully visible until collapsed.
 */
const FloorCollapsibleSection = ({
  title,
  count = null,
  isOpen = true,
  onToggle,
  children,
  className = '',
  headerClassName = '',
  bodyClassName = ''
}) => {
  const countLabel =
    count == null ? null : `${count} unit${count === 1 ? '' : 's'}`;

  return (
    <div className={className}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-left rounded-md border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors ${headerClassName}`}>
        <span className="flex items-center gap-2 min-w-0">
          <ChevronDown
            size={16}
            className={`shrink-0 text-gray-500 transition-transform ${
              isOpen ? 'rotate-0' : '-rotate-90'
            }`}
          />
          <span className="text-sm font-semibold text-gray-800 truncate">
            {title}
          </span>
          {countLabel != null && (
            <span className="text-xs text-gray-500 shrink-0">({countLabel})</span>
          )}
        </span>
      </button>
      {isOpen ? <div className={bodyClassName}>{children}</div> : null}
    </div>
  );
};

/**
 * Table header row for floor/block groups inside unit tables.
 */
export const FloorTableGroupHeader = ({
  title,
  count = null,
  isOpen = true,
  onToggle,
  colSpan = 1,
  labelPrefix = 'Floor ',
  className = 'bg-gray-50 border-b border-gray-200',
  buttonClassName = 'inline-flex items-center gap-2 text-left text-sm font-semibold text-gray-800 hover:text-gray-950',
  cellClassName = 'px-3 py-2'
}) => {
  const countLabel =
    count == null ? null : `${count} unit${count === 1 ? '' : 's'}`;

  return (
    <tr className={className}>
      <td colSpan={colSpan} className={cellClassName}>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          className={buttonClassName}>
          <ChevronDown
            size={16}
            className={`shrink-0 text-gray-500 transition-transform ${
              isOpen ? 'rotate-0' : '-rotate-90'
            }`}
          />
          <span>
            {labelPrefix}
            {title}
            {countLabel != null ? (
              <span className="ml-1 font-normal text-gray-500">({countLabel})</span>
            ) : null}
          </span>
        </button>
      </td>
    </tr>
  );
};

export default FloorCollapsibleSection;
